import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import ApiClient from "./API/ApiClient";

const Vigilance = () => {
  const { language = "en" } = useParams();
  const homePage = useSelector((state) => state.homePage);
  const { getRequestApi, postRequestApi } = ApiClient();
  const [quizData, setQuizData] = useState([]);
  const [dynamicText, setDynamicText] = useState({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState({});
  const [showResult, setShowResult] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [showCongratulations, setShowCongratulations] = useState(false);
  const [showUserInfoForm, setShowUserInfoForm] = useState(false);
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const loadQuizData = async () => {
    const response1 = await getRequestApi(`post/vigilancequiz/${language}`);
    if (response1.status) {
      console.log(response1.data);
      setDynamicText(response1.data.post_meta);
    }
    const response = await getRequestApi(
      `post/type/vigilance-quiz/${language}`
    );

    if (response.status) {
      setQuizData(response.data);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadQuizData();
  }, []);

  const navigate = useNavigate();

  const handleOptionSelect = (optionKey, optionValue) => {
    setSelectedOption(optionKey);
    setUserAnswers((prev) => ({
      ...prev,
      [currentQuestionIndex]: {
        selectedOption: optionKey,
        selectedValue: optionValue,
        isCorrect: optionKey === currentQuestion?.post_meta?.correct_answer,
      },
    }));
  };

  const handleNext = () => {
    if (currentQuestionIndex < quizData.length - 1) {
      setCurrentQuestionIndex((prev) => prev + 1);
      setSelectedOption(
        userAnswers[currentQuestionIndex + 1]?.selectedOption || ""
      );
    } else {
      setShowResult(true);
    }
  };

  const handlePrev = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex((prev) => prev - 1);
      setSelectedOption(
        userAnswers[currentQuestionIndex - 1]?.selectedOption || ""
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowResult(true);
  };

  const handleGetCertificate = () => {
    setShowUserInfoForm(true);
  };

  const handleUserInfoSubmit = async (e) => {
    e.preventDefault();
    // Validate form
    if (!userInfo.name || !userInfo.email || !userInfo.phone) {
      alert("Please fill all fields");
      return;
    }
    await postRequestApi(`subscribe/vigilance`, userInfo);
    // Show congratulations page
    setShowCongratulations(true);
    setShowUserInfoForm(false);
  };

  const handleUserInfoChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      // Remove any non-digit characters and limit to 10 digits
      const numbersOnly = value.replace(/\D/g, "").slice(0, 10);
      setUserInfo((prev) => ({
        ...prev,
        [name]: numbersOnly,
      }));
    } else {
      setUserInfo((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handlePrintCertificate = () => {
    // Create a new window for printing
    const printWindow = window.open("", "_blank");

    // Get the certificate image source
    const certificateImg = document.getElementById("certificate");
    const imgSrc = certificateImg?.src || "/certificate.jpg";

    // Create print content with only the image
    const printContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Certificate</title>
        <style>
          body { 
            margin: 0; 
            padding: 20px; 
            display: flex; 
            justify-content: center; 
            align-items: center; 
            min-height: 100vh;
            background: white;
          }
          img { 
            max-width: 100%; 
            height: auto; 
            display: block;
            border: 1px solid #ddd;
          }
          @media print {
          @page {
              size: landscape;
              margin: 0;
            }
            body { 
              margin: 0; 
              padding: 0;
            }
            img { 
              width: 100%; 
              height: 100%;
              object-fit: contain;
            }
          }
        </style>
      </head>
      <body>
        <img src="${imgSrc}" alt="Certificate" onload="window.print(); setTimeout(() => window.close(), 1000);" />
        <script>
          // Fallback in case onload doesn't fire
         
        </script>
      </body>
    </html>
  `;

    printWindow.document.write(printContent);
    printWindow.document.close();
  };
  const resetQuiz = () => {
    setCurrentQuestionIndex(0);
    setUserAnswers({});
    setShowResult(false);
    setShowCongratulations(false);
    setShowUserInfoForm(false);
    setUserInfo({
      name: "",
      email: "",
      phone: "",
    });
    setSelectedOption("");
  };

  const currentQuestion = quizData[currentQuestionIndex];
  const currentAnswer = userAnswers[currentQuestionIndex];
  const isCorrect = currentAnswer?.isCorrect;
  const correctAnswerKey = currentQuestion?.post_meta?.correct_answer;

  // Hide preloader when content is loaded
  useEffect(() => {
    if (!isLoading) {
      const preloader = document.getElementById("preloader");
      if (preloader) {
        preloader.style.display = "none";
      }
    }
  }, [isLoading]);

  useEffect(() => {
    if (!showCongratulations || !userInfo?.name) return;

    const drawCertificate = async () => {
      const img = document.getElementById("certificate");
      if (!img) return;

      // Wait for font
      await document.fonts.load("400 50px 'Peristiwa'");

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;

      ctx.drawImage(img, 0, 0);

      // Detect screen width for responsive font size
      let fontSize = 100; // default for desktop
      if (window.innerWidth < 768) {
        fontSize = 45; // smaller font for mobile
      } else if (window.innerWidth < 1024) {
        fontSize = 70; // medium for tablets
      }

      ctx.font = `400 ${fontSize}px 'Peristiwa', sans-serif`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      ctx.fillText(
        userInfo?.name || "Your Name",
        canvas.width / 2,
        canvas.height / 1.9
      );

      img.src = canvas.toDataURL("image/png");
    };

    const timer = requestAnimationFrame(() => {
      const img = document.getElementById("certificate");
      if (!img) return;

      if (img.complete && img.naturalWidth > 0) {
        drawCertificate();
      } else {
        img.onload = drawCertificate;
      }
    });

    return () => cancelAnimationFrame(timer);
  }, [userInfo?.name, showCongratulations]);

  if (isLoading) {
    return (
      <>
        <div id="preloader" style={{ display: "block" }}>
          <div data-loader="circle-side"></div>
        </div>
      </>
    );
  }

  if (showUserInfoForm) {
    return (
      <div className="style_3">
        <header>
          <div className="container">
            <Link to="/">
              <img
                src="https://nfdcindia.com/nfdcapi/apifile/webp/1728384644227_9148917.webp"
                alt="NFDC Cinemas of India logo"
                width="120"
                role="img"
                aria-label="NFDC Cinemas of India logo"
                // aria-labelledby="NFDC Cinemas of India logo"
              />
            </Link>
          </div>
        </header>

        <div className="wrapper_centering">
          <div className="container_centering">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-6">
                  <div className="user-info-form result-page-btn">
                    <div className="text-center mb-5">
                      <h3 className="mb-3">
                        {dynamicText?.form_heading ?? "Enter Your Details"}
                      </h3>
                      <p className="lead">
                        {dynamicText?.form_subheading ??
                          "Please provide your information to generate the certificate"}
                      </p>
                    </div>

                    <form onSubmit={handleUserInfoSubmit}>
                      <div className="mb-4">
                        <label htmlFor="name" className="form-label">
                          {dynamicText?.form_field_1 ?? "Full Name *"}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          value={userInfo.name}
                          onChange={handleUserInfoChange}
                          required
                          placeholder="Enter your full name"
                        />
                      </div>

                      <div className="mb-4">
                        <label htmlFor="email" className="form-label">
                          {dynamicText?.form_field_2 ?? "Email *"}
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          value={userInfo.email}
                          onChange={handleUserInfoChange}
                          required
                          placeholder="Enter your email address"
                        />
                      </div>

                      <div className="mb-4">
                        <label htmlFor="phone" className="form-label">
                          {dynamicText?.form_field_3 ?? " Phone Number *"}
                        </label>
                        <input
                          type="tel"
                          className="form-control"
                          id="phone"
                          name="phone"
                          value={userInfo.phone}
                          onChange={handleUserInfoChange}
                          required
                          maxLength="10"
                          pattern="[0-9]{10}"
                          placeholder="Enter your phone number"
                        />
                      </div>

                      <div className="text-center mt-5">
                        <button
                          type="submit"
                          className="btn yellow-btn btn-lg me-3"
                        >
                          {dynamicText?.generate_button_text ??
                            "Generate Certificate"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowUserInfoForm(false)}
                        >
                          {dynamicText?.Backtoresulttext ?? " Back to Results"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showCongratulations) {
    return (
      <div className="style_3">
        <header>
          <div className="container">
            <Link to="/">
              <img
                src="https://nfdcindia.com/nfdcapi/apifile/webp/1728384644227_9148917.webp"
                alt="NFDC Cinemas of India logo"
                width="120"
                role="img"
                aria-label="NFDC Cinemas of India logo"
                // aria-labelledby="NFDC Cinemas of India logo"
              />
            </Link>
          </div>
        </header>

        <div className="wrapper_centering">
          <div className="container_centering">
            <div className="container">
              <div className="text-center">
                <div className="main_title_1">
                  <div className="pb-0 thank-you">
                    <img
                      src="/assets/quiz/img/tick-unscreen.gif"
                      width="200"
                      alt="Select gif"
                    />
                  </div>
                  <h3 className="pt-0">
                    <span>
                      {" "}
                      {dynamicText?.congratulations_heading ??
                        "Congratulations!"}{" "}
                    </span>
                  </h3>
                  <p className="typing">
                    {dynamicText?.congratulations_sub_text ??
                      " Thank you for participating."}
                    <br />
                    {dynamicText?.congratulations_text ??
                      "You can download your certificate here, and a copy has also been sent to your registered email address."}
                  </p>
                </div>

                {/* Certificate Preview */}
                <div className="col-sm-8 mx-auto">
                  <div className="certificate-preview p-2 border bg-white shadow">
                    <img
                      id="certificate"
                      src="/certificate.jpg"
                      className="img-fluid"
                    />
                  </div>

                  <div className="mt-4 mb-4 result-page-btn ">
                    <button
                      className="common-btn-quiz me-3"
                      onClick={handlePrintCertificate}
                    >
                      {dynamicText?.print_certificate_text ??
                        "Print Certificate"}
                    </button>
                    <button
                      className="btn btn-outline-secondary me-3"
                      onClick={() => {
                        setShowCongratulations(false);
                        setShowUserInfoForm(false);
                        setShowResult(true);
                      }}
                    >
                      {dynamicText?.Backtoresulttext ?? " Back to Results"}
                    </button>
                    <Link to="/" className="btn btn-outline-secondary ">
                      {dynamicText?.back_to_home ?? " Back to Home"}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showResult) {
    // Calculate score
    const totalQuestions = quizData.length;
    const correctAnswers = Object.values(userAnswers).filter(
      (answer) => answer.isCorrect
    ).length;
    const score = Math.round((correctAnswers / totalQuestions) * 100);

    return (
      <div className="style_3">
        <header>
          <div className="container">
            <Link to="/">
              <img
                src="https://nfdcindia.com/nfdcapi/apifile/webp/1728384644227_9148917.webp"
                alt="NFDC Cinemas of India logo"
                width="120"
                role="img"
                aria-label="NFDC Cinemas of India logo"
                // aria-labelledby="NFDC Cinemas of India logo"
              />
            </Link>
          </div>
        </header>

        <div className="wrapper_centering">
          <div className="container_centering">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="quiz-results">
                    {/* Score Summary */}
                    <div className="text-center mb-5">
                      <h3 className="mb-3">
                        {dynamicText?.result_heading ?? "Quiz Results"}
                      </h3>
                      <div className="score-display mb-4">
                        <h4
                          className={`${
                            score >= 70 ? "text-success" : "text-danger"
                          }`}
                        >
                          {dynamicText?.scrore ?? "Score:"} Score:{" "}
                          {correctAnswers}/{totalQuestions} ({score}%)
                        </h4>
                        <p className="lead">
                          {score >= 70
                            ? dynamicText?.result_text_score_70 ??
                              "Great job! You've passed the quiz.:"
                            : dynamicText?.result_text_less_score_70 ??
                              "Keep learning! You can try again."}
                        </p>
                      </div>
                    </div>

                    {/* Detailed Results */}
                    <div className="results-details">
                      {quizData.map((question, index) => {
                        const userAnswer = userAnswers[index];
                        const isCorrect = userAnswer?.isCorrect;
                        const correctAnswerKey =
                          question.post_meta.correct_answer;
                        const correctAnswer =
                          question.post_meta[correctAnswerKey];

                        return (
                          <div
                            key={question.id}
                            className={`result-item mb-4 p-4 rounded ${
                              isCorrect
                                ? "border-success bg-light"
                                : "border-danger bg-light"
                            }`}
                          >
                            <div className="d-flex align-items-start mb-3">
                              <span
                                className={`badge ${
                                  isCorrect ? "bg-success" : "bg-danger"
                                } me-3`}
                              >
                                Q{index + 1}
                              </span>
                              <h5 className="mb-0 flex-grow-1">
                                {question.title}
                              </h5>
                            </div>

                            <div className="row">
                              <div className="col-md-6">
                                <p
                                  className={`mb-2 ${
                                    !isCorrect ? "text-danger fw-bold" : ""
                                  }`}
                                >
                                  <strong>
                                    {dynamicText?.answer ?? "Your Answer:"}
                                  </strong>{" "}
                                  {userAnswer?.selectedValue || "Not answered"}
                                  {!isCorrect && userAnswer && " ✗"}
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p className="mb-2 text-success">
                                  <strong>
                                    {dynamicText?.correct_answer ??
                                      "Correct Answer:"}
                                  </strong>{" "}
                                  {correctAnswer} ✓
                                </p>
                              </div>
                            </div>

                            <div className="mt-3 p-3 bg-white rounded">
                              <strong>
                                {dynamicText?.explanation ?? "Explanation:"}
                              </strong>{" "}
                              {isCorrect
                                ? question.post_meta.right_answer_destricption
                                : question.post_meta.wrong_answer_destricption}
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {/* Action Buttons */}
                    <div className="text-center mt-5 result-page-btn">
                      <button
                        className="btn yellow-btn btn-lg me-3"
                        onClick={handleGetCertificate}
                      >
                        {dynamicText?.get_certificate ?? "Get Certificate"}
                      </button>
                      <button
                        className="btn btn-secondary me-3"
                        onClick={resetQuiz}
                      >
                        {dynamicText?.take_quiz_again ?? "Take Quiz Again"}
                      </button>
                      <Link to="/" className="btn btn-outline-secondary">
                        {dynamicText?.back_to_home ?? " Back to Home"}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Main quiz interface
  return (
    <>
      <div className="style_3">
        {/* Preloader - Hidden when content loads */}
        <div id="preloader" style={{ display: isLoading ? "block" : "none" }}>
          <div data-loader="circle-side"></div>
        </div>

        {/* Loader Form */}
        <div id="loader_form">
          <div data-loader="circle-side-2"></div>
        </div>

        {/* Header */}
        <header>
          <div className="container">
            <Link to="/">
              <img
                src="https://nfdcindia.com/nfdcapi/apifile/webp/1728384644227_9148917.webp"
                alt="NFDC Cinemas of India logo"
                width="120"
                role="img"
                aria-label="NFDC Cinemas of India logo"
                // aria-labelledby="NFDC Cinemas of India logo"
              />
            </Link>
          </div>
        </header>

        {/* Main Content */}
        <div className="wrapper_centering">
          <div className="container_centering">
            <div className="container">
              <div className="row justify-content-between">
                {/* Left Side - Description */}
                <div className="col-xl-6 col-lg-6 d-flex align-items-center">
                  <div className="main_title_1">
                    <h3>
                      <img
                        src="/assets/quiz/img/main_icon_1.svg"
                        width="80"
                        height="80"
                        alt="Icone for Quize"
                      />
                      <span>{dynamicText?.Quiz_heading ?? "Quiz"}</span>
                    </h3>
                    <p className="typing">
                      {dynamicText?.quiz_subhead ??
                        "Test your knowledge with this awareness quiz. Select the correct answers and learn more about each topic."}
                    </p>
                    <p>
                      <em>- {dynamicText?.nfdc_team ?? "The NFDC Team"}</em>
                    </p>
                  </div>
                </div>

                {/* Right Side - Form */}
                <div className="col-xl-5 col-lg-5">
                  <div id="wizard_container">
                    <div id="top-wizard">
                      <div id="top-wizard">
                        <div
                          id="progressbar"
                          style={{
                            marginTop: "20px",
                            width: `${(currentQuestionIndex / 10) * 100}%`,
                            height: "2px",
                            backgroundColor: "#4caf50",
                            borderRadius: "4px",
                            transition: "width 0.4s ease",
                          }}
                        ></div>
                      </div>
                    </div>

                    <form
                      id="wrapped"
                      onSubmit={handleSubmit}
                      autoComplete="off"
                    >
                      {/* Security field */}
                      <input
                        id="website"
                        name="website"
                        type="text"
                        defaultValue=""
                        style={{ display: "none" }}
                      />

                      <div id="middle-wizard">
                        <div className="step">
                          <h3 className="main_question mb-4">
                            <strong className="pb-3">
                              {currentQuestionIndex + 1} of {quizData.length}
                            </strong>
                            {currentQuestion?.title}
                          </h3>

                          {/* Show result for current question if answered */}

                          <div className="review_block">
                            <ul>
                              {[
                                {
                                  key: "option_first",
                                  label:
                                    currentQuestion?.post_meta?.option_first,
                                },
                                {
                                  key: "option_two",
                                  label: currentQuestion?.post_meta?.option_two,
                                },
                                {
                                  key: "option_three",
                                  label:
                                    currentQuestion?.post_meta?.option_three,
                                },
                                {
                                  key: "option_four",
                                  label:
                                    currentQuestion?.post_meta?.option_four,
                                },
                              ].map((option) => (
                                <li key={option.key}>
                                  <div className="checkbox_radio_container">
                                    <input
                                      type="radio"
                                      id={option.key}
                                      name="quiz_option"
                                      className="required"
                                      value={option.key}
                                      onChange={() =>
                                        handleOptionSelect(
                                          option.key,
                                          option.label
                                        )
                                      }
                                      checked={selectedOption === option.key}
                                      disabled={currentAnswer} // Disable after selection
                                    />
                                    <label
                                      className={`radio ${
                                        currentAnswer
                                          ? option.key === correctAnswerKey
                                            ? "correct"
                                            : option.key === selectedOption
                                            ? "incorrect"
                                            : ""
                                          : ""
                                      }`}
                                      htmlFor={option.key}
                                    ></label>
                                    <label
                                      htmlFor={option.key}
                                      className={`wrapper ${
                                        currentAnswer
                                          ? option.key === correctAnswerKey
                                            ? "text-success fw-bold"
                                            : option.key === selectedOption
                                            ? "text-danger-option"
                                            : ""
                                          : ""
                                      }`}
                                    >
                                      {currentAnswer &&
                                        option.key === selectedOption &&
                                        !isCorrect && (
                                          <span className="wrongcheck">✗</span>
                                        )}
                                      {option.label}{" "}
                                      {currentAnswer &&
                                        option.key === correctAnswerKey && (
                                          <span className="correctcheck">
                                            ✓
                                          </span>
                                        )}
                                    </label>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                          {currentAnswer && (
                            <div
                              className={`alert ${
                                isCorrect ? "alert-success" : "alert-danger"
                              } mb-3`}
                            >
                              <strong>
                                {isCorrect ? "Correct! ✓" : "Incorrect! ✗"}
                              </strong>
                              <div className="mt-2">
                                {isCorrect
                                  ? currentQuestion.post_meta
                                      .right_answer_destricption
                                  : currentQuestion.post_meta
                                      .wrong_answer_destricption}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Navigation Buttons */}
                      <div id="bottom-wizard">
                        <button
                          type="button"
                          name="backward"
                          className="backward"
                          onClick={handlePrev}
                          disabled={currentQuestionIndex === 0}
                        >
                          {dynamicText?.prev_text ?? "Prev"}
                        </button>

                        <button
                          type="button"
                          name="forward"
                          className="forward"
                          onClick={handleNext}
                          disabled={!selectedOption}
                        >
                          {currentQuestionIndex < quizData.length - 1
                            ? dynamicText?.next_text ?? "Next"
                            : dynamicText?.submit ?? "Submit Quiz"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Vigilance;
